import {Injectable} from '@angular/core';
import * as DeviceCartsActions from './deviceCarts.actions';
import {map} from 'rxjs/operators';
import {DeviceCartsPartialState} from './deviceCarts.reducer';
import {Actions, createEffect} from '@ngrx/effects';
import {DataPersistence, withCorrelationIdOf} from '@kion/ngrx-helper';
import {DeviceCart} from '@kion/data-models';
import {DeviceCartConnectors} from "./deviceCart.connectors";

@Injectable()
export class DeviceCartsEffects {
  loadCartByDevice$ = createEffect(() =>
    this.dataPersistence.fetch(
      DeviceCartsActions.loadCartByDevice,
      {
        run: (
          action: ReturnType<typeof DeviceCartsActions.loadCartByDevice>
        ) => {
          return this.backend.getCartForDevice(action.factory, action.deviceId).pipe(
            map(
              (response: DeviceCart) => withCorrelationIdOf(
                action,
                DeviceCartsActions.loadCartByDeviceSuccess({deviceCart: {...response, deviceId: action.deviceId}})
              )
            )
          )
        },
        onError: (
          action: ReturnType<typeof DeviceCartsActions.loadCartByDevice>,
          error
        ) => {
          console.error("Error", error);
          return withCorrelationIdOf(
            action,
            DeviceCartsActions.loadCartByDeviceError({error: error})
          )
        }
      }
    )
  );
  addToCart$ = createEffect(() =>
    this.dataPersistence.fetch(
      DeviceCartsActions.addToCart,
      {
        run: (
          action: ReturnType<typeof DeviceCartsActions.addToCart>
        ) => {
          return this.backend.addToCart(action.factory, action.deviceId, action.id, action.featureId, action.salesRule).pipe(
            map(
              (response: DeviceCart) => withCorrelationIdOf(
                action,
                DeviceCartsActions.addToCartSuccess({deviceCart: {...response, deviceId: action.deviceId}})
              )
            )
          )
        },
        onError: (
          action: ReturnType<typeof DeviceCartsActions.addToCart>,
          error
        ) => {
          console.error("Error", error);
          return withCorrelationIdOf(
            action,
            DeviceCartsActions.addToCartError({error: error})
          )
        }
      }
    )
  );
  saveCart$ = createEffect(() =>
    this.dataPersistence.fetch(
      DeviceCartsActions.saveCart,
      {
        run: (
          action: ReturnType<typeof DeviceCartsActions.saveCart>
        ) => {
          return this.backend.saveCart(action.factory, action.deviceId, action.id).pipe(
            map(
              (response: DeviceCart) => withCorrelationIdOf(
                action,
                DeviceCartsActions.saveCartSuccess({deviceCart: {...response, deviceId: action.deviceId}})
              )
            )
          )
        },
        onError: (
          action: ReturnType<typeof DeviceCartsActions.saveCart>,
          error
        ) => {
          console.error("Error", error);
          return withCorrelationIdOf(
            action,
            DeviceCartsActions.saveCartError({error: error})
          );
        }
      }
    )
  );
  placeOrder$ = createEffect(() =>
    this.dataPersistence.fetch(
      DeviceCartsActions.placeOrder,
      {
        run: (
          action: ReturnType<typeof DeviceCartsActions.placeOrder>
        ) => {
          return this.backend.placeOrder(action.cartId).pipe(
            map(
              (response: string) => withCorrelationIdOf(
                action,
                DeviceCartsActions.placeOrderSuccess({orderNumber: response, deviceCartId: action.cartId}))
            )
          )
        },
        onError: (
          action: ReturnType<typeof DeviceCartsActions.placeOrder>,
          error
        ) => {
          console.error('Error', error);
          return withCorrelationIdOf(action, DeviceCartsActions.placeOrderError({error: error}))
        }
      }
    )
  );
  removeFromCart$ = createEffect(() =>
    this.dataPersistence.fetch(
      DeviceCartsActions.removeFromCart,
      {
        run: (
          action: ReturnType<typeof DeviceCartsActions.removeFromCart>
        ) => {
          return this.backend.removeFromCart(
            action.factory,
            action.deviceId,
            action.cartId,
            action.entry
          ).pipe(
            map(
              (response: DeviceCart) => withCorrelationIdOf(
                action,
                DeviceCartsActions.removeFromCartSuccess({deviceCart: {...response, deviceId: action.deviceId}})
              )
            )
          )
        },
        onError: (
          action: ReturnType<typeof DeviceCartsActions.removeFromCart>,
          error
        ) => {
          console.error("Error", error);
          return withCorrelationIdOf(
            action,
            DeviceCartsActions.removeFromCartError({error: error})
          )
        }
      }
    )
  );
  updateCart$ = createEffect(() =>
    this.dataPersistence.fetch(
      DeviceCartsActions.updateCart,
      {
        run: (
          action: ReturnType<typeof DeviceCartsActions.updateCart>
        ) => {
          return this.backend.update(
            action.factory,
            action.deviceId,
            action.quoteId,
            action.status,
            action.note,
            action.poNumber,
            action.ccRecipients,
            action.poDate,
            action.cartId
          ).pipe(
            map(
              (response: DeviceCart) => withCorrelationIdOf(
                action,
                DeviceCartsActions.updateCartSuccess({deviceCart: {...response, deviceId: action.deviceId}})
              )
            )
          )
        },
        onError: (
          action: ReturnType<typeof DeviceCartsActions.updateCart>,
          error
        ) => {
          console.error("Error", error);
          return withCorrelationIdOf(
            action,
            DeviceCartsActions.updateCartError({error: error})
          )
        }
      }
    )
  );
  deleteCart$ = createEffect(() =>
    this.dataPersistence.fetch(
      DeviceCartsActions.deleteCart,
      {
        run: (
          action: ReturnType<typeof DeviceCartsActions.deleteCart>
        ) => {
          return this.backend.delete(action.factory, action.deviceId).pipe(
            map(
              () => withCorrelationIdOf(
                action,
                DeviceCartsActions.deleteCartSuccess({cartId: action.cartId})
              )
            )
          )
        },
        onError: (
          action: ReturnType<typeof DeviceCartsActions.deleteCart>,
          error
        ) => {
          console.error("Error", error);
          return withCorrelationIdOf(
            action,
            DeviceCartsActions.deleteCartError({error: error})
          );
        }
      }
    )
  );

  constructor(
    private actions$: Actions,
    private dataPersistence: DataPersistence<DeviceCartsPartialState>,
    private backend: DeviceCartConnectors
  ) {
  }
}

